import {
  lucideArrowLeft,
  lucideBadgePercent,
  lucideCalendar,
  lucideCalendarClock,
  lucideCalendarDays,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideCircleParking,
  lucideCircleUser,
  lucideCircleX,
  lucideClock,
  lucideCookie,
  lucideCreditCard,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGamepad,
  lucideGlobe,
  lucideHandCoins,
  lucideHouse,
  lucideInfo,
  lucideKeyRound,
  lucideLink,
  lucideLeaf,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucideMapPin,
  lucideMapPinned,
  lucideMessageCircle,
  lucideMessageSquareWarning,
  lucideNewspaper,
  lucidePartyPopper,
  lucidePhone,
  lucideQrCode,
  lucideRefreshCw,
  lucideReceiptText,
  lucideShoppingBasket,
  lucideSmartphone,
  lucideSquareUser,
  lucideStar,
  lucideStore,
  lucideTrophy,
  lucideTag,
  lucideTvMinimal,
  lucideUserCheck,
  lucideUser,
  lucideUserPlus,
  lucideUsers,
  lucideUserX,
  lucideWifi,
  lucideX,
  lucideGift,
  lucidePackageOpen,
  lucideHourglass,
  lucidePen,
  lucideCirclePlus,
  lucideTicket,
  lucideGamepad2,
  lucideLogOut,
  lucideBan,
  lucideLink2,
  lucideLink2Off,
  lucideShoppingCart
} from '@ng-icons/lucide';

export const ICONS_MAP = {
  lucideArrowLeft,
  lucideBadgePercent,
  lucideCalendar,
  lucideCalendarClock,
  lucideCalendarDays,
  lucideCamera,
  lucideCheck,
  lucideCookie,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideCircleParking,
  lucideCircleUser,
  lucideCircleX,
  lucideClock,
  lucideCreditCard,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGamepad,
  lucideGlobe,
  lucideHandCoins,
  lucideHouse,
  lucideInfo,
  lucideKeyRound,
  lucideLink,
  lucideLink2,
  lucideLink2Off,
  lucideLeaf,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucideMapPin,
  lucideMapPinned,
  lucideMessageCircle,
  lucideMessageSquareWarning,
  lucideNewspaper,
  lucidePartyPopper,
  lucidePhone,
  lucideQrCode,
  lucideRefreshCw,
  lucideReceiptText,
  lucideShoppingBasket,
  lucideSmartphone,
  lucideSquareUser,
  lucideStar,
  lucideStore,
  lucideTag,
  lucideTrophy,
  lucideTvMinimal,
  lucideUserCheck,
  lucideUser,
  lucideUserPlus,
  lucideUsers,
  lucideUserX,
  lucideWifi,
  lucideX,
  lucideGift,
  lucidePackageOpen,
  lucideHourglass,
  lucidePen,
  lucideCirclePlus,
  lucideTicket,
  lucideGamepad2,
  lucideLogOut,
  lucideBan,
  lucideShoppingCart,
};

type LucideIcon = keyof typeof ICONS_MAP;

export const ICONS_NAME_MAP = {
  'arrow-left': 'lucideArrowLeft',
  calendar: 'lucideCalendar',
  'calendar-clock': 'lucideCalendarClock',
  'calendar-days': 'lucideCalendarDays',
  camera: 'lucideCamera',
  check: 'lucideCheck',
  cookie: 'lucideCookie',
  'chevron-down': 'lucideChevronDown',
  'chevron-left': 'lucideChevronLeft',
  'chevron-right': 'lucideChevronRight',
  'circle-alert': 'lucideCircleAlert',
  'circle-check': 'lucideCircleCheck',
  'circle-x': 'lucideCircleX',
  clock: 'lucideClock',
  'credit-card': 'lucideCreditCard',
  deal: 'lucideBadgePercent',
  email: 'lucideMail',
  'eye-off': 'lucideEyeOff',
  eye: 'lucideEye',
  'file-text': 'lucideFileText',
  gamepad: 'lucideGamepad',
  home: 'lucideHouse',
  info: 'lucideInfo',
  'key-round': 'lucideKeyRound',
  link: 'lucideLink',
  leaf: 'lucideLeaf',
  'lock-keyhole': 'lucideLockKeyhole',
  'mail-check': 'lucideMailCheck',
  'map-pin': 'lucideMapPin',
  'map-pinned': 'lucideMapPinned',
  'message-important': 'lucideMessageSquareWarning',
  messages: 'lucideMessageCircle',
  newspaper: 'lucideNewspaper',
  parking: 'lucideCircleParking',
  phone: 'lucidePhone',
  'party-popper': 'lucidePartyPopper',
  'qr-code': 'lucideQrCode',
  'refresh-cw': 'lucideRefreshCw',
  'receipt-text': 'lucideReceiptText',
  screen: 'lucideTvMinimal',
  'shopping-basket': 'lucideShoppingBasket',
  smartphone: 'lucideSmartphone',
  'square-user': 'lucideSquareUser',
  star: 'lucideStar',
  store: 'lucideStore',
  tag: 'lucideTag',
  trophy: 'lucideTrophy',
  'user': 'lucideUser',
  'user-check': 'lucideUserCheck',
  'user-circle': 'lucideCircleUser',
  'user-plus': 'lucideUserPlus',
  users: 'lucideUsers',
  'user-x': 'lucideUserX',
  website: 'lucideGlobe',
  x: 'lucideX',
  wifi: 'lucideWifi',
  'hand-coins': 'lucideHandCoins',
  gift: 'lucideGift',
  'package-open': 'lucidePackageOpen',
  hourglass: 'lucideHourglass',
  pen: 'lucidePen',
  'circle-plus': 'lucideCirclePlus',
  confetti: 'lucidePartyPopper',
  'delete-account': 'lucideUserX',
  plant: 'lucideLeaf',
  ticket: 'lucideTicket',
  'gamepad-2': 'lucideGamepad2',
  'log-out': 'lucideLogOut',
  'ban': 'lucideBan',
  'link-2': 'lucideLink2',
  'link-2-off': 'lucideLink2Off',
  'shopping-cart': 'lucideShoppingCart',
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS_NAME_MAP;
